const ParkedOvernightValues = {
    CAR_PORT: 'CAR_PORT',
    PUBLIC_CONDO_APT_PARKING: 'PUBLIC_CONDO_APT_PARKING',
    PUBLIC_PARKING_LOT: 'PUBLIC_PARKING_LOT',
    PUBLIC_UNDERGROUND_PARKING: 'PUBLIC_UNDERGROUND_PARKING',
    PRIVATE_DRIVEWAY: 'PRIVATE_DRIVEWAY',
    PRIVATE_GARAGE: 'PRIVATE_GARAGE',
    PRIVATE_CONDO_APT_PARKING: 'PRIVATE_CONDO_APT_PARKING',
    STORAGE: 'STORAGE',
    STREET: 'STREET',
    OTHER: 'OTHER',
};

export default ParkedOvernightValues;
